import { useState } from 'react';

import { useSemenStats } from '../../stats/contexts/stats';
import StatsView, { StatsFilters, OffspringPanel } from '../../stats/layouts/entity-stats';

const todayStr = () => new Date().toLocaleDateString('en-CA');
const yearStart = () => `${new Date().getFullYear()}-01-01`;

// Estadísticas de un SEMEN/TORO (admin-stats.md): performance del lote; el funnel
// arranca en embriones. Filtros: rango por fecha del clivage + cliente/finca.
export default function SemenStats({ semenId }) {
    const [range, setRange] = useState({ from: yearStart(), to: todayStr() });
    const [scope, setScope] = useState({ client_id: '', farm_id: '' });
    const [active, setActive] = useState(null);

    const pick = (item, type) => {
        if (type === 'farm') { setScope({ client_id: '', farm_id: String(item.id) }); setActive({ type, label: `${item.name}${item.owner?.name ? ` · ${item.owner.name}` : ''}` }); }
        else { setScope({ client_id: String(item.id), farm_id: '' }); setActive({ type, label: item.name }); }
    };
    const clearScope = () => { setScope({ client_id: '', farm_id: '' }); setActive(null); };

    const { data, isLoading, isFetching, error } = useSemenStats(semenId, { ...range, ...scope });
    const name = data?.entity?.name || data?.entity?.code || `#${semenId}`;

    return (
        <StatsView
            data={data} isLoading={isLoading} isFetching={isFetching} error={error}
            title={`Toro · ${name}`}
            subtitle="Performance del semen (rendimiento del lote/toro)."
            backTo={`/admin/semen/${semenId}`} backLabel="Volver al semen"
            filters={<StatsFilters range={range} onRange={(p) => setRange((r) => ({ ...r, ...p }))} withScope active={active} onPick={pick} onClear={clearScope} busy={isFetching} />}
        >
            <OffspringPanel title="Progenie (genealogía)" data={data?.progeny} />
        </StatsView>
    );
}
